import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { GeofenceItem } from './GeofenceItem'

type Props = RenderItemProps<'geofences'>

export function Item(props: Props) {
  return props.type === 'item' ? <GeofenceItem {...props} /> : null
}
